function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "local_mall_24px"
}, React.createElement("path", {
  id: "icon/maps/local_mall_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 6.5H17C17 3.73999 14.76 1.5 12 1.5C9.23999 1.5 7 3.73999 7 6.5H5C3.90002 6.5 3 7.40002 3 8.5V20.5C3 21.6 3.90002 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V8.5C21 7.40002 20.1 6.5 19 6.5ZM12 3.5C13.66 3.5 15 4.84003 15 6.5H9C9 4.84003 10.34 3.5 12 3.5ZM7.15997 9.75C7.70996 11.91 9.66998 13.5 12 13.5C14.33 13.5 16.29 11.91 16.84 9.75C17 9.12 16.52 8.5 15.87 8.5C15.4 8.5 15.02 8.84003 14.89 9.29999C14.54 10.57 13.3799 11.5 12 11.5C10.62 11.5 9.45996 10.57 9.10999 9.29999C8.97998 8.84003 8.59998 8.5 8.12994 8.5C7.47998 8.5 6.98999 9.12 7.15997 9.75Z",
  fill: "black",
  fillOpacity: 0.54
}));

var SvgEkowisata = function SvgEkowisata(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEkowisata, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ekowisata.1770abed.svg";
export { ForwardRef as ReactComponent };